<template>
  <div id="leftAccountPageWrapper" class="page" refs="leftAccountPage">
    <div id="leftAccountPageDefault">
      <el-row class="hp-row content-default" type="flex">
        <el-col class="center">
          <div :class="['gradient-card', 'default', { 'plain-card': $utils.isPageForLicenses() }]">
            <div class="header">
              <h4 class="title"></h4>
            </div>
            <div class="body">
              <div class="icon"></div>

              <div class="text-wrapper">
                <div class="text account-left">{{`${$t('label.youHaveLeftAccount')}:`}}</div>
                <div class="text account-name">{{accountName}}</div>
              </div>

              <el-button class="cstm-btn-white" @click="handleContinueClick">{{$t('label.continue')}}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script src="./left-account.js"></script>
<style lang="scss" src="./left-account.scss"></style>
